/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedScenarioRequestDto } from '../../models/backend-patched-scenario-request-dto';
import { BackendScenarioDto } from '../../models/backend-scenario-dto';

export interface ProjectCalculationsVariantsKitsPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedScenarioRequestDto;
}

export function projectCalculationsVariantsKitsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectCalculationsVariantsKitsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendScenarioDto>> {
  const rb = new RequestBuilder(rootUrl, projectCalculationsVariantsKitsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendScenarioDto>;
    }),
  );
}

projectCalculationsVariantsKitsPartialUpdate$FormData.PATH = '/api/project_calculations/variants_kits/{id}/';
